import { forwardRef, HTMLAttributes } from "react";

export type Props = HTMLAttributes<HTMLDivElement> & {
  /** Additional CSS classes */
  className?: string;
  /** Test ID for testing */
  "data-testid"?: string;
};

/**
 * Base horizontal line/divider component with no styling.
 * A simple unstyled divider element.
 *
 * @example
 * // In shared/ui/HorizontalLine.tsx
 * import { HorizontalLineBase } from "@core/ui";
 *
 * export function HorizontalLine() {
 *   return (
 *     <HorizontalLineBase className="h-[1px] border-b border-brand-300 w-full" />
 *   );
 * }
 */
export const HorizontalLineBase = forwardRef<HTMLDivElement, Props>(
  ({ className, "data-testid": testId = "horizontal-line", ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="separator"
        className={className}
        data-testid={testId}
        {...props}
      />
    );
  }
);

HorizontalLineBase.displayName = "HorizontalLineBase";

